/**
 * <LogoImage> — drop-in per qualsiasi logo di squadra.
 * Usa /api/logo per rimuovere lo sfondo automaticamente.
 * Props identiche a <img> standard.
 */
import React from 'react'

interface LogoImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt: string
  threshold?: number  // tolleranza flood fill (default 20)
}

export default function LogoImage({ src, alt, threshold, className, ...rest }: LogoImageProps) {
  const params = new URLSearchParams({ src })
  if (threshold !== undefined) params.set('threshold', String(threshold))
  // Cache-busting: forza aggiornamento quando il file cambia
  params.set('v', '4')
  const apiSrc = `/api/logo?${params}`

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={apiSrc}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      {...rest}
    />
  )
}
